export function isNativeApp() {
  return typeof window !== 'undefined' &&
    window.Capacitor !== undefined &&
    window.Capacitor.isNativePlatform();
}

export function isAndroid() {
  return isNativeApp() && window.Capacitor.getPlatform() === 'android';
}
